module.exports = __webpack_public_path__ + "img/Food Donation to Mama.1edbfc81.jpg";